import { render, staticRenderFns } from "./dividas.vue?vue&type=template&id=0cb9b71f&scoped=true&"
import script from "./dividas.vue?vue&type=script&lang=js&"
export * from "./dividas.vue?vue&type=script&lang=js&"
import style0 from "./dividas.vue?vue&type=style&index=0&id=0cb9b71f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb9b71f",
  null
  
)

export default component.exports